import { useEffect, useRef, useState, useCallback } from "react";
import { API, fetchWsTicket } from "@/lib/api";

const WS_URL = API.replace(/^http/, "ws");

export default function usePresence({ enabled = true, onReact } = {}) {
  const [active, setActive] = useState(0);
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);
  const reconnectTimer = useRef(null);

  const send = useCallback((msg) => {
    const ws = wsRef.current;
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify(msg));
    }
  }, []);

  const sendReact = useCallback((post_id, emotion) => {
    send({ type: "react", post_id, emotion });
  }, [send]);

  useEffect(() => {
    if (!enabled) return;
    let stopped = false;

    const connect = async () => {
      if (stopped) return;
      const ticket = await fetchWsTicket();
      if (!ticket || stopped) return;
      const ws = new WebSocket(`${WS_URL}/ws/presence?token=${encodeURIComponent(ticket)}`);
      wsRef.current = ws;
      ws.onopen = () => setConnected(true);
      ws.onclose = () => {
        setConnected(false);
        if (!stopped) {
          reconnectTimer.current = setTimeout(connect, 2500);
        }
      };
      ws.onerror = () => {};
      ws.onmessage = (ev) => {
        try {
          const data = JSON.parse(ev.data);
          if (data.type === "presence") setActive(data.active);
          else if (data.type === "react" && onReact) onReact(data);
        } catch (e) {
          console.warn("[usePresence] malformed ws message", e);
        }
      };
    };
    connect();
    return () => {
      stopped = true;
      clearTimeout(reconnectTimer.current);
      try { wsRef.current?.close(); } catch (e) {
        console.warn("[usePresence] ws close failed", e);
      }
    };
  }, [enabled, onReact]);

  return { active, connected, sendReact };
}
